"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkTheaterForm = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LinkTheaterForm = require("./LinkTheaterForm.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LinkTheaterForm = exports.LinkTheaterForm = function LinkTheaterForm(_ref) {
  var theaters = _ref.theaters,
    defaultValue = _ref.defaultValue,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? false : _ref$editMode;
  var _useState = (0, _react.useState)(defaultValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedTheater = _useState2[0],
    setSelectedTheater = _useState2[1];
  var primaryBtnText = editMode ? 'Save' : 'Add';
  var onSelectChange = function onSelectChange(event) {
    setSelectedTheater(event.currentTarget.value);
  };
  var submitHandler = function submitHandler(e) {
    e.preventDefault();
    onSubmit(selectedTheater);
  };
  var cancelHandler = function cancelHandler(e) {
    e.preventDefault();
    onCancel();
  };
  var renderOptions = theaters.map(function (_ref2, index) {
    var label = _ref2.label,
      value = _ref2.value;
    var key = "".concat(index, "-").concat(label, "-").concat(value);
    return _react["default"].createElement("option", {
      key: key,
      value: value
    }, label);
  });
  var disableDefaultOption = !!selectedTheater;
  return _react["default"].createElement(_LinkTheaterForm.StyledLinkTheaterForm, {
    onSubmit: submitHandler
  }, _react["default"].createElement(_LinkTheaterForm.StyledText, null, "Create a new theater or link to one that has already been created. Note: not all functionality will be available if you choose to embed the stream on a third party!"), _react["default"].createElement(_LinkTheaterForm.StyledDropdownLabel, null, "Link Theater"), _react["default"].createElement(_LinkTheaterForm.StyledSelect, {
    onChange: onSelectChange,
    defaultValue: selectedTheater,
    "data-testid": "theater-dropdown"
  }, _react["default"].createElement("option", {
    disabled: disableDefaultOption
  }, "Select Theater"), renderOptions), _react["default"].createElement(_LinkTheaterForm.Flex, null, _react["default"].createElement(_LinkTheaterForm.StyledPrimaryButton, {
    "data-testid": "submit-btn",
    onClick: submitHandler,
    disabled: !disableDefaultOption
  }, primaryBtnText), _react["default"].createElement(_LinkTheaterForm.StyledSecondaryButton, {
    "data-testid": "cancel-btn",
    color: "light",
    variant: "outlined",
    type: "reset",
    onClick: cancelHandler
  }, "Cancel")));
};
LinkTheaterForm.propTypes = {
  theaters: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  })).isRequired,
  defaultValue: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  editMode: _propTypes["default"].bool
};